import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { TopNavbarStyled } from '../TopNavbarStyled';
import { rem } from 'polished';

export const TopNavbarStyledAP = styled(TopNavbarStyled)`
    .topnavbar-grid {
        display: flex;
    }
    .topnavbar-returnlink {
        display: flex;
        flex: none;
        width: auto;
        align-items: center;

        &__text {
            display: none;
        }

        @media (min-width: ${breakpoints.md}px) {
            min-width: 6.5rem;
            border: 1px solid ${({ theme }) => theme.colors.primaryBlack};

            &__text {
                display: block;
            }
        }

        .icon-wrapper {
            height: unset;
            
            svg {
                with: 15px;
                height: 15px;

                path {
                    stroke: ${({ theme }) => theme.colors.primaryBlack};
                }
            }
        }

        &__text {
            font-size: ${({ theme }) => theme.fontSizes.textSmall};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            margin-top: 0.25em;
        }

        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.white};
            border-color: ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.primary};

            .icon-wrapper {
                svg {
                    path {
                        stroke: ${({ theme }) => theme.colors.white};
                    }
                }
            }
        }
    }
    .content {
        display: flex;
        flex: auto;

        &-title {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            margin-left: -${rem(10)};

            @media (min-width: ${breakpoints.md}px) {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                font-size: ${rem(18)};
            }
        }
    }

    .save-button {
        font-size: ${({ theme }) => theme.fontSizes.textTiny};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.primaryBlack};
        border-color: ${({ theme }) => theme.colors.primaryBlack};
        
        :hover:enabled { {
            color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
            background-color: ${({ theme }) => theme.colors.white};
        }
    }
`;
